import { ChangeEvent } from "react";
import { SignupId as ScreenProvider } from "@auth0/auth0-acul-js";

export default function SignupId() {
    // Initialize the SDK for this screen
    const screenProvider = new ScreenProvider();
    screenProvider.transaction.alternateConnections
    // Handle the submit action
    const formSubmitHandler = (event: ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        const identifierInput = event.target.querySelector("input#identifier") as HTMLInputElement;
        screenProvider.signup({ email: identifierInput?.value });
    };

    const styles = {
        card: {
            maxWidth: '400px',
            margin: '0 auto',
            padding: '2rem',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            background: 'white',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        },
        cardHeader: {
            textAlign: 'center' as const,
            marginBottom: '2rem'
        },
        cardTitle: {
            fontSize: '1.875rem',
            fontWeight: 500,
            marginBottom: '0.5rem',
            color: '#111827'
        },
        cardDescription: {
            color: '#6b7280',
            marginBottom: 0
        },
        inputGroup: {
            marginBottom: '1rem'
        },
        label: {
            display: 'block',
            marginBottom: '0.5rem',
            fontWeight: 500,
            color: '#374151'
        },
        input: {
            width: '100%',
            padding: '0.75rem',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            fontSize: '1rem',
            boxSizing: 'border-box' as const
        },
        button: {
            width: '100%',
            padding: '0.75rem 1rem',
            border: 'none',
            borderRadius: '6px',
            fontSize: '1rem',
            cursor: 'pointer',
            marginBottom: '1rem',
            backgroundColor: '#3b82f6',
            color: 'white'
        },
        footerText: {
            textAlign: 'center' as const,
            color: '#6b7280',
            fontSize: '0.875rem'
        },
        link: {
            color: '#3b82f6',
            textDecoration: 'none',
            marginLeft: '0.25rem'
        }
    };

    return (
        <div style={styles.card}>
            <form noValidate onSubmit={formSubmitHandler}>
                <div style={styles.cardHeader}>
                    <h1 style={styles.cardTitle}>
                        {screenProvider.screen.texts?.title ?? "Welcome"}
                    </h1>
                    <p style={styles.cardDescription}>
                        {screenProvider.screen.texts?.description ?? "Create your account"}
                    </p>
                </div>

                <div>
                    <div style={styles.inputGroup}>
                        <label htmlFor="identifier" style={styles.label}>
                            {screenProvider.screen.texts?.emailPlaceholder ?? "Enter your email"}
                        </label>
                        <input
                            type="email"
                            id="identifier"
                            name="identifier"
                            style={styles.input}

                        />
                    </div>

                    <button type="submit" style={styles.button}>
                        {screenProvider.screen.texts?.buttonText ?? "Continue"}
                    </button>

                    <p style={styles.footerText}>
                        {screenProvider.screen.texts?.footerText ?? "Already have an account?"}
                        <a href={screenProvider.screen.loginLink ?? "#"} style={styles.link}>
                            {screenProvider.screen.texts?.footerLinkText ?? "Log into your account"}
                        </a>
                    </p>
                </div>
            </form>
        </div>
    );
}